<template>
<div class="pinterest-share-wrapper">
  <span
    class="pinterest-button"
    @click="shareOnPinterest"
  >
    <WellIcon icon="pinterest" type="custom-icons" :size="24" />
  </span>
  <slot />
</div>
</template>

<script lang="ts" setup>
import WellIcon from '@/components/common/WellIcon.vue';

const props = defineProps<{
  image?: string
  description?: string
}>()

const shareOnPinterest = () => {
  const baseUrl = 'https://www.pinterest.com/pin/create/button/';
    const params = new URLSearchParams({
      url: window.location.href,
      media: props.image || '',
      description: props.description || '',
  });
  window.open(`${baseUrl}?${params.toString()}`, '_blank')
}
</script>

<style scoped>
.pinterest-share-wrapper {
  position: relative;
  &:hover {
    .pinterest-button {
      display: flex;
    }
  }
}
.pinterest-button {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--primary-contrast);
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>